<template>
  <div>
    <v-container>
      <v-row>
        <v-col cols="12" xs="12" sm="12" md="12" class="py-0 my-0">
          <v-text-field
            label="Subject"
            class="py-0 my-0"
            v-model="model.subject"
          ></v-text-field>
        </v-col>
      </v-row>
      <quill-editor
        :options="editorOption"
        v-model="model.message"
      ></quill-editor>
      <v-divider></v-divider>
      <v-row>
        <v-col cols="12" xs="12" sm="12" md="12">
          <v-btn color="success" :loading="isSaving" @click.stop="save"
            >Save</v-btn
          >
        </v-col>
        <v-col>
          <v-card>
            <v-container>
              <p>
                These are the following fields that you can use for the Email.
                To use these field. Kindly Input and use the curly brackets eg.
                <b>{ApplicantName}</b>
              </p>
              <v-simple-table dense>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left">Field Name</th>
                      <th class="text-left">Value</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="item in items" :key="item.field">
                      <td style="width: 200px;">{{ item.field }}</td>
                      <td>{{ item.value }}</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-container>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";

import { quillEditor } from "vue-quill-editor";
import EmployeeSelection from "@/views/maintenance/employee-masterfile/personal-info/NewSelection";
import isEmpty from "lodash/isEmpty";
const API_ENDPOINT = "/api/onboardingEmailNotif";
export default {
  data: () => ({
    classPadding: "my-0 py-0",
    model: {
      transType: "PIIPS",
    },
    editorOption: {
      /* quill options */
    },
    items: [
      {
        field: "Person Incharge",
        value: "{PersonIncharge}",
      },
      {
        field: "Employee Name",
        value: "{EmployeeName}",
      },
      {
        field: "Sequence",
        value: "{Sequence}",
      },
      {
        field: "Sub Sequence",
        value: "{SubSequence}",
      },
      {
        field: "New Hire Steps",
        value: "{NewHireSteps}",
      },
      {
        field: "Target Activity Date",
        value: "{TargetActivityDate}",
      },
    ],
    isSaving: false,
  }),
  components: {
    EmployeeSelection,
    quillEditor,
  },
  methods: {
    save() {
      this.isSaving = true;
      this.$axios
        .post(`${API_ENDPOINT}`, this.model)
        .then(({ data }) => {
          this.$toast.success(data.message);
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        })
        .finally(() => {
          this.isSaving = false;
        });
    },
    getSetup() {
      this.$axios
        .get(`${API_ENDPOINT}/${this.model.transType}`)
        .then(({ data }) => {
          if (!isEmpty(data)) this.model = data;
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        });
    },
  },
  created() {
    this.getSetup();
  },
};
</script>
